import React from 'react'
import { Spinner } from '@enterprise-ui/canvas-ui-react'
import './Overlay.scss'

/**
 * Overlay - overlay/backdrop component that optionally displays
 * a centered spinner and/or a message. Useful for indicating an
 * in-progress or blocked state over existing UI.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.message] - Optional message text displayed below the spinner.
 * @param {boolean} [props.showSpinner=false] - Whether to show the centered spinner.
 * @param {string} [props.longWaitAriaAlert] - Accessible alert string forwarded to Spinner for long waits.
 * @returns {JSX.Element}
 */

// TODO: Remove this folder once we consume the Overlay from item-component post canvas 8 migration
const Overlay = ({ message, showSpinner = false, longWaitAriaAlert }) => {
  const hasContent = !!(
    showSpinner ||
    (message && String(message).trim().length)
  )

  return (
    <div className="iac-overlay__backdrop align-centre-centre">
      {hasContent && (
        <div className="iac-overlay__box hc8-pa-6x hc8-bg-base">
          {showSpinner && (
            <div className="hc8-mb-2x">
              <Spinner
                size="lg"
                longWaitAriaAlert={longWaitAriaAlert || 'Please wait'}
              />
            </div>
          )}
          {message && (
            <div className="hc8-fs-200 hc8-clr-base hc8-ta-center">
              <strong>{message}</strong>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default Overlay
